import { HttpAction } from "@megaron/http-service";
import { syncResultSerializer } from "@megaron/import-export";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

import { itemSerializer } from "./items";

export const shopifyProductVariantSerializer = Serializers.object({
  variantId: Serializers.string,
  sku: Serializers.string,
  productId: Serializers.string,
  variantTitle: Serializers.string,
  barcode: Serializers.string,
  weightKg: Serializers.float,
});

export type ShopifyProductVariant = SerializerValue<typeof shopifyProductVariantSerializer>;

export const shopifyProductSerialzier = Serializers.object({
  id: Serializers.string,
  title: Serializers.string,
  description: Serializers.string,
  vendor: Serializers.string,
  handle: Serializers.string,
  tags: Serializers.string.array(),
});

export type ShopifyProduct = SerializerValue<typeof shopifyProductSerialzier>;

export const bcItemSerializer = Serializers.object({
  bcId: uuidSerializer,
  itemId: Serializers.string,
  itemName: Serializers.string,
  gtin: Serializers.string.nullable({ emptyStrAsNull: true }),
});

export type BcItem = SerializerValue<typeof bcItemSerializer>;

export const exportItemsOptionsSerializer = Serializers.object({
  googleSheets: Serializers.object({
    spreadsheetId: Serializers.string.optional(),
    sheetTitle: Serializers.string.optional(),
    accessToken: Serializers.string.optional(),
  }),
  csv: Serializers.object({
    delimiter: Serializers.string,
    headerMapping: Serializers.record(Serializers.stringOneOf(...itemSerializer.keys), Serializers.string),
  }).partial(),
  json: Serializers.object({}),
}).partial();

export type ExportItemsOptions = SerializerValue<typeof exportItemsOptionsSerializer>;

export const exportItemsActions = {
  exportItems: HttpAction({
    path: "/items/export",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: Serializers.object({
      dryRun: Serializers.boolean.optional(),
      ...exportItemsOptionsSerializer.fields,
    }),
    valueSerializer: Serializers.object({
      ...syncResultSerializer(itemSerializer.fields).fields,
      ...Serializers.object({
        json: itemSerializer.partial().array().optional(),
        csv: Serializers.string.optional(),
        googleSheets: Serializers.object({
          spreadsheetId: Serializers.string.optional(),
          sheetTitle: Serializers.string.optional(),
        }).optional(),
      }).partial().fields,
    }),
  }),

  exportShopifyProducts: HttpAction({
    path: "/items/export/shopifyProducts",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: Serializers.object({
      dryRun: Serializers.boolean,
    }),
    valueSerializer: syncResultSerializer(shopifyProductSerialzier.fields),
  }),

  exportShopifyProductVariants: HttpAction({
    path: "/items/export/shopifyProductVariants",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: Serializers.object({
      dryRun: Serializers.boolean,
    }),
    valueSerializer: syncResultSerializer(shopifyProductVariantSerializer.fields),
  }),

  exportBcItems: HttpAction({
    path: "/items/export/bcItems",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: Serializers.object({
      dryRun: Serializers.boolean,
    }),
    valueSerializer: syncResultSerializer(bcItemSerializer.fields),
  }),
};
